import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import { cloneElement } from 'react';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { getTestId } from '../../utils/testId.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Spacer } from '../Spacer/Spacer.js';
import { Container } from '../Container/Container.js';
import { Text } from '../Text/Text.js';

var styles = {
  "empty-state": "web_ui__EmptyState__empty-state"
};

var cssClasses = classNames.bind(styles);
var EmptyState = function EmptyState(_ref) {
  var title = _ref.title,
    body = _ref.body,
    _ref$allowHtml = _ref.allowHtml,
    allowHtml = _ref$allowHtml === void 0 ? false : _ref$allowHtml,
    action = _ref.action,
    testId = _ref.testId,
    icon = _ref.icon,
    image = _ref.image,
    animation = _ref.animation;
  var renderContent = function renderContent() {
    if (!title && !body) return null;
    return /*#__PURE__*/jsxs(Container, {
      styling: "wide",
      children: [title ? /*#__PURE__*/jsx(Text, {
        as: "h1",
        text: title,
        type: "heading",
        alignment: "center",
        testId: getTestId(testId, 'title')
      }) : null, title && body ? /*#__PURE__*/jsx(Spacer, {
        size: "x-large"
      }) : null, body ? /*#__PURE__*/jsx(Text, {
        as: "span",
        text: body,
        html: allowHtml,
        alignment: "center",
        testId: getTestId(testId, 'body')
      }) : null]
    });
  };
  var renderMedia = function renderMedia(name, element, enforceDefaultMediaSize) {
    if (!element) return null;
    var defaultMediaSize = 'x2-large';
    var elementHasSizeProp = Object.prototype.hasOwnProperty.call(element.props, 'size');
    var canUseDefaultMediaSize = enforceDefaultMediaSize || !elementHasSizeProp;
    var elementSize = canUseDefaultMediaSize ? defaultMediaSize : element.props.size;
    return /*#__PURE__*/cloneElement(element, _objectSpread(_objectSpread({}, element.props), {}, {
      size: elementSize,
      testId: element.props.testId || getTestId(testId, name)
    }));
  };
  var emptyStateClass = cssClasses('empty-state');
  return /*#__PURE__*/jsxs("div", {
    className: emptyStateClass,
    "data-testid": testId,
    children: [/*#__PURE__*/jsx(Spacer, {
      size: "x2-large"
    }), renderMedia('icon', icon), renderMedia('image', image), renderMedia('animation', animation), renderContent(), action ? /*#__PURE__*/jsx("div", {
      "data-testid": getTestId(testId, 'action'),
      children: action
    }) : null, /*#__PURE__*/jsx(Spacer, {
      size: "x2-large"
    })]
  });
};

export { EmptyState as default };
//# sourceMappingURL=EmptyState.js.map
